<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Blog from '../../../model/blog.js';
import { VueContentLoading } from 'vue-content-loading';
import 'vue-advanced-cropper/dist/style.css';
import InputTag from 'vue-input-tag';
import VueEditor from '@/components/Vue2Editor'

export default {
  page: {
    title: "ماذا نقدم",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError,  VueContentLoading, InputTag, VueEditor },
  data() {
    return {
      // limit tag
      limit:10,

      title: "تعديل",
      items: [
        {
          text: "ماذا نقدم",
          href: "/blogs",
        },
        {
          text: "تعديل ماذا نقدم",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      blog: new Blog,
      submitadd: false,
      loadingButton: false,
      loadingContent: false,
    };
  },
  // vuelidate
  validations: {
    blog: {
      title_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), minLength: minLength(2), maxLength: maxLength(300) },
      locales: {required}
    },  
  },
  computed:{
    ...mapGetters('blog', ['getBlog']),
  },
  methods: {
    ...mapActions("blog", ['get', 'edit']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    getEditorImages(){
      let images = []
      if(this.checkLocale('ar')) images = [...this.$refs.editor1.$data.images]
      if(this.checkLocale('en')) images = [...images, ...this.$refs.editor2.$data.images]
      if(this.checkLocale('fa')) images = [...images, ...this.$refs.editor3.$data.images]
      return images
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.$refs.image.value = null
    },
    checkLocale(locale){
      return this.blog.locales.includes(locale);
    },
    checkValidate(){
      return !this.$v.blog.locales.$error &&
        (!this.checkLocale('ar') || !this.$v.blog.title_ar.$error) && 
        (!this.checkLocale('en') || !this.$v.blog.title_en.$error) && 
        (!this.checkLocale('fa') || !this.$v.blog.title_fa.$error) 
    },
    formEditBlog(published = false) {
      this.submitadd = true;
      this.$v.$touch();
      if(!this.checkValidate()) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.blog.published = published 
      this.blog.editor_images = this.getEditorImages()

      this.edit({
        id: this.id,
        blog: this.blog.toFormData()
      }).then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    }
  },
  created(){
    this.get(this.id)
    .then(()=>{
      this.blog = this.getBlog
      this.loadingContent = true
    })
  },
  mounted(){
  }
};
</script>


<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent">

              <AlertError :errors="errors"></AlertError>

              <div class="row mt-3">
                <b-form-group class="col-md-12 mb-3" label="حدد اللغة :">
                  <b-form-checkbox class="dis-inline" v-model="blog.locales" value="ar" plain>عربي</b-form-checkbox>
                  <b-form-checkbox class="dis-inline" v-model="blog.locales" value="en" plain>انكليزي</b-form-checkbox>
                  <!-- <b-form-checkbox class="dis-inline" v-model="blog.locales" value="fa" plain>فارسي</b-form-checkbox> -->
                  <div v-if="submitadd && $v.blog.locales.$error" class="invalid-check">
                    <span v-if="!$v.blog.locales.required"> يجب اختيار لغة واحدة على الاقل </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="blog.locales.includes('ar')" class="col-md-12 mb-3 class_ar" label="العنوان : ( عربي )" label-for="title_ar" >
                  <b-form-input id="title_ar" v-model.trim="blog.title_ar" :class="{ 'is-invalid': submitadd && $v.blog.title_ar.$error }" placeholder="ادخل العنوان" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.blog.title_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.blog.title_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.blog.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.blog.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="blog.locales.includes('en')" class="col-md-12 mb-3 class_en" label="العنوان : ( انجليزي )" label-for="title-en" >
                  <b-form-input id="title-en" v-model.trim="blog.title_en" :class="{ 'is-invalid': submitadd && $v.blog.title_en.$error }" placeholder="ادخل العنوان" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.blog.title_en.$error" class="invalid-feedback">
                    <span v-if="!$v.blog.title_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.blog.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.blog.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="blog.locales.includes('fa')" class="col-md-12 mb-3 class_fa" label="العنوان : ( فارسي )" label-for="title-fa" >
                  <b-form-input id="title-fa" v-model.trim="blog.title_fa" :class="{ 'is-invalid': submitadd && $v.blog.title_fa.$error }" placeholder="ادخل العنوان" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.blog.title_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.blog.title_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.blog.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.blog.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>
                
                <!-- Editor -->
                <b-form-group v-show="blog.locales.includes('ar')" class="col-md-12 mb-3 class_ar" label=" المحتوى : ( عربي )" label-for="editor" >
                  <vueEditor id="editor1" ref="editor1" v-model="blog.content_ar" />
                </b-form-group>
                <b-form-group v-show="blog.locales.includes('en')" class="col-md-12 mb-3 class_en" label=" المحتوى : ( انجليزي )" label-for="editor2" >
                  <vueEditor id="editor2" ref="editor2" v-model="blog.content_en" />
                </b-form-group>
                <b-form-group v-show="blog.locales.includes('fa')" class="col-md-12 mb-3 class_fa" label=" المحتوى : ( فارسي )" label-for="editor3" >
                  <vueEditor id="editor3" ref="editor3" v-model="blog.content_fa" />
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="الكلمات المفتاحية :" label-for="tag" >
                  <input-tag class="form-control" placeholder="اضافة" :limit="limit" validate="" v-model="blog.tags"></input-tag>
                </b-form-group>

              </div>

              <div class="mt-3">
                <hr>
                <b-button :disabled="loadingButton" @click="formEditBlog(false)" variant="primary" type="button" class="me-2"> 
                  <b-spinner v-if="loadingButton && !blog.published" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
                </b-button>

                <b-button :disabled="loadingButton" @click="formEditBlog(true)" variant="success" type="button"> 
                  <b-spinner v-if="loadingButton && blog.published " small></b-spinner>
                  <span v-else><i class="bx bx-paper-plane font-size-16 align-middle me-2"></i>نشر</span>
                </b-button>

                <router-link :to="{ name: 'offer.index' }">
                  <b-button class="f-left" type="button" variant="secondary">رجوع</b-button>
                </router-link>
              </div>
            </b-form>
            
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="250">
                <rect x="0" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="8" rx="1" ry="1" width="4" height="4" />
                <rect x="6" y="10" rx="1" ry="1" width="10" height="1" />
                <rect x="20" y="08" rx="1" ry="1" width="4" height="4" />
                <rect x="26" y="10" rx="1" ry="1" width="10" height="1" />
                <rect x="40" y="8" rx="1" ry="1" width="4" height="4" />
                <rect x="46" y="10" rx="1" ry="1" width="10" height="1" />

                <rect x="0" y="18" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="22" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="37" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="41" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="56" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="60" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="75" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="79" rx="1" ry="1" width="380" height="10" />
                <rect x="381" y="79" rx="1" ry="1" width="19" height="10" />

                <rect x="0" y="94" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="98" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="139" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="143" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="184" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="188" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="231" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="236" rx="1" ry="1" width="20" height="10" />
                <rect x="22" y="236" rx="1" ry="1" width="20" height="10" />
                <rect x="385" y="236" rx="1" ry="1" width="15" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>